import React from 'react';
import '../styles/Tooltip.css';
import { colour } from '../styles/GlobalStyles';
import { Beak, Exit } from '../assets/icons';
import { IconButton } from './';
import { renderHTML } from '../functions';

function Tooltip(props) {
    const type = props.type;
    const title = props.title;
    const body = props.body;
    const position = props.position;
    const className = `tooltip-beak-${position}`;
    const contextTooltipBg = props.contextTooltipBg;
    const visible = props.visible;
    const exit = props.exit;
    const exitFunc = props.exitFunc;
    const customClass = props.customClass;
    const markdown = props.markdown ?? false;
    const hideBeak = props.hideBeak ?? false;
    const bodyColorClass = props.bodyColorClass;
    const bodyColoredPart = props.bodyColoredPart;
    const bodyRest = props.bodyRest;

    return (
        type === "info" ?
        <div className={"tooltip-outer-container " + (customClass)}>
            <div className="tooltip-inner-container relative-container">
                {
                    exit === true &&
                    <IconButton
                        size="medium"
                        icon={<Exit fill={colour.gray07} size={16} className="tooltip-exit-icon" clickFunc={null} />}
                        disabled={false}
                        clickFunc={exitFunc}
                        standardIcon={false}
                        background={true}
                        bgType={"white"}
                        contextTooltip={false}
                        contextTooltipBG={null}
                        contextTooltipText={null}
                        customClass={"tooltip-exit-container"}
                    />
                }
                {!hideBeak && (
                    <div className="tooltip-beak-container">
                         <Beak
                            className={"tooltip-beak " + (className)}
                            fill={colour.gray00}
                        />
                    </div>
                )}
                <div className="tooltip-text-container">
                    {
                        title !== null &&
                        <h2 className="body-bold colour-primary">
                            {title}
                        </h2>
                    }
                    {
                        markdown === true ?
                        <div
                            className={"tooltip-markdown-container body-regular colour-primary typewriter-text-gap"}
                            dangerouslySetInnerHTML={{ __html: renderHTML(body) }}
                        />
                        :
                        bodyColoredPart && bodyRest ? (
                            <span className="body-regular">
                                <span className={bodyColorClass || 'colour-primary'}>{bodyColoredPart}</span>
                                <span className="colour-primary">{bodyRest}</span>
                            </span>
                        ) : (
                            <span className={`body-regular ${bodyColorClass || 'colour-primary'}`}>
                                {body}
                            </span>
                        )
                    }
                </div>
            </div>
        </div>
        :
        <div className={"tooltip-context-outer-container " + (visible === true ? "visible " : "") + (contextTooltipBg === "dark" ? "bg-colour-dark" : "bg-colour-white")}>
            <div className="tooltip-context-inner-container">
                <span className={"body-regular block-text text-align-center " + (contextTooltipBg === "dark" ? "colour-white" : "colour-primary")}>
                    {body}
                </span>
            </div>
        </div>
    )
};

export default Tooltip;